import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getEmailActionLabels,
  getEmailRecipientLabels,
} from '../../../../../../../configs/email';
import Action from './Action';

function EmailConfiguration(): JSX.Element {
  const { t } = useTranslation();

  const emailActionLabels = useMemo(() => getEmailActionLabels(t), [t]);
  const emailRecipientLabels = useMemo(() => getEmailRecipientLabels(t), [t]);

  return (
    <article className="field-with-errors">
      {Object.keys(emailActionLabels).map((key) => (
        <Action
          key={key}
          emailAction={parseInt(key)}
          emailActionLabels={emailActionLabels}
          emailRecipientLabels={emailRecipientLabels}
        />
      ))}
    </article>
  );
}

export default EmailConfiguration;
